<template>
  <div class="pa-2 px-3">
     <h1 style="margin: 0; font-size: 1.4rem">Welcome to Routine,<br> 
                your personal overview of recurring routine tasks, a digital interpretation of the Kamishibai Task Board. 

                 <h5 style="font-weight: 400; margin-top: 11px">A coproduction of <a :href="oyenLinkedIn" target="_blank">Jörg Oyen</a> design and basic idea <a :href="oyenLink" target="_blank">02.2018</a>, and <a :href="lukas" target="_blank">Lukas Kreutzer</a> coding, rework with vuejs and firebase <a :href="oyen" target="_blank">08.2019</a>.</h5>
                </h1>
  </div>
</template>

<script>
export default {
  data () {
    return {
      oyenLinkedIn: 'https://www.linkedin.com/in/joergoyen/',
      oyen: 'https://routine.oyen.de',
      oyenLink: 'https://oyen.de/dev/routine/',
      lukas: 'https://www.linkedin.com/in/lukas-kreutzer/',
    }
  }
}
</script>

<style>
h1 {
  color: #F2F2F2 !important;
}
</style>